import extractLastOptions from "../../../utils/extract-last-options";
import convertPropertyToTimeline from "./convert-property-to-timeline";

/**
 *
 * @param {String} trigger
 * @param {String} properties
 * @param {Boolean} isCluster
 */
const convertClusterToTimeline = (trigger, properties, isCluster) => {
  const results = [];

  /** Remove brackets */
  const sliced = isCluster ? properties.slice(1, -1) : properties;

  /** Get options */
  const data = extractLastOptions(sliced);

  /** Check if options */
  const hasOptions = data.get("options");

  /** Prepare options string */
  const options = hasOptions ? hasOptions.slice(1, -1) : "";

  /** Remove the last options */
  const clean = sliced.replace(`<${options}>`, "");

  /** Split multiple properties in the cluster */
  const split = clean.split("▥");

  for (const property of split) {
    /** Convert single property into timeline format */
    const result = convertPropertyToTimeline(trigger, property, options);

    results.push(result);
  }

  return results;
};

export default convertClusterToTimeline;
